module.exports = __webpack_public_path__ + "img/fi-rr-feather.aa46e381.svg";